<template>
  <div class="dashboard">
    <TopNav data-v-demo-welcome="0" />
    <DeployFilter v-if="selectedProject" :projectID="selectedProject.id" />
    <div class="section">
      <div class="columns">
        <div class="column is-2" v-if="projects">
          <LeftMenu  data-v-tour-projects="0" :projects="projects" :selectedProject="selectedId" />
        </div>

        <div class="column">
          <ProjectData v-if="selectedProject" :project="selectedProject" />
        </div>
      </div>
    </div>

    <v-tour name="hotpathTour" :steps="tourSteps" />
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import LeftMenu from "@/components/LeftMenu.vue";
import ProjectData from "@/components/ProjectData.vue";
import TopNav from "@/components/TopNav.vue";
import DeployFilter from "@/components/DeployFilter.vue";

export default {
  name: "hotpaths",
  components: {
    LeftMenu,
    ProjectData,
    TopNav,
    DeployFilter
  },
  props: {
    selectedId: {
      type: Number,
      default: 0 // project ID will always be > 0 in the backend / DB
    }
  },
  apollo: {
    projects: gql`
      {
        projects {
          id
          name
        }
      }
    `
  },
  data() {
    return {
      projects: [],
      tourSteps: [
        {
          target: '[data-v-demo-welcome="0"]',
          header: {
            title: "Welcome to Mindsight!"
          },
          content: '<p>This tour will walk you through all that the Mindsight dashboard has to offer. Follow all the steps in the tour to get an overview of how to use the dashboard and how this information can help you and your team create better software.</p><p><br>To read detailed instructions that show how to set up Mindsight in your project, have a look at our <a href="https://docs.mindsight.io">documentation</a>.</p>'
        },
        {
          target: '[data-v-tour-projects="0"]',
          header: {
            title: "Projects"
          },
          content: "<p>These are all the projects tracked by Mindsight</p><p><br>Each project might roughly correspond to a repository, and represents a whole application's measurements. An application might consist of several microservices or several deployment environments you wish to observe (i.e. production vs. staging)</p>"
        },
        {
          target: '[data-v-demo-fn="0"]',
          header: {
            title: "Activity Tracker"
          },
          content: "<p>This is your most active function in this project since the last deployment. The percentage indicates how often Mindsight has observed it to be running.</p> <p><br>Click on the function's name to see more detailed information about what it's been up to recently.</p>",
          params: {
            placement: "bottom"
          }
        },
        {
          target: '[data-v-demo-deploys="0"]',
          header: {
            title: "Track Code Behavior Changes"
          },
          content: "<p>Mindsight is able to instrument your deployment process to keep track of how your code changes affect the application's real-world behavior in its production environment.</p><p><br>Select a deployment below to see how the current deployment compares with past behavior.</p>"
        }
      ]
    };
  },
  computed: {
    selectedProject() {
      if (this.selectedId == 0 && this.projects.length > 0) {
        return this.projects[0];
      }

      for (let p of this.projects) {
        if (this.selectedId == p.id) {
          return p;
        }
      }

      return null;
    }
  },
  mounted() {
    if (process.env.VUE_APP_DEMO) {
      window.setTimeout(() => {
        this.$tours["hotpathTour"].start();
      }, 2000);
    }
  }
};
</script>


<style>
.dashboard {
  background: #fafcff;
}
</style>
